import * as React from "react";

function SvgEventLog(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.31 2.877C9.31 1.288 11 0 12.103 0H16c1.5 0 2.75 1.288 2.75 2.877V4H21v4c0 .794-.229 1-1 1H8c-.771 0-1-.206-1-1V4h2.31V2.877zM14 6a2 2 0 100-4 2 2 0 000 4z"
        fill="#fff"
      />
      <path
        d="M7 27.02H3.009v3.97H7v-3.97zM3 21h3.991v3.97H3V21zM6.991 15.029H3V19h3.991v-3.971zM9.009 26.99H13v3.971H9.009v-3.97zM12.991 20.97H9v3.972h3.991v-3.971zM9 15h3.991v3.97H9V15zM19 27.02h-3.991v3.97H19v-3.97zM15 21h3.991v3.97H15V21zM18.991 15.029H15V19h3.991v-3.971zM21.009 26.99H25v3.971h-3.991v-3.97zM24.991 20.97H21v3.972h3.991v-3.971zM21 15h3.991v3.97H21V15z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6H4v1H2.5C.572 7 0 9.072 0 11v23h27.948V10.731C27.948 8.803 26.385 7 24.457 7H24V6h-2v2c0 1.5-.5 2-2 2H8c-1.5 0-2-.5-2-2V6zM1 33V13h25.948v20H1z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgEventLog;
